import { Box } from '@mui/material'
import React from 'react'
import ViewAndEditModalFooter from './ViewAndEditModalFooter'
import ViewAndEditModalHeader from './ViewAndEditModalHeader'
import { genericViewAndEditType } from './viewAndEditTypes'

import "./viewAndEdit.css"

const ViewAndEditModal = (props:genericViewAndEditType) => {
  return (
    <Box className="modal-box">
        <ViewAndEditModalHeader message={props.message} close={props.closeModal}/>
        {props.children}
        <ViewAndEditModalFooter buttonText={props.buttonText} updateMethod={props.updateMethod} check={props.check}/>
    </Box>
  )
}

export default ViewAndEditModal